import React from 'react';
import EditButton from '../../ui/EditButton';
import { getRequiredJoinDocuments } from '../utils/documentUtils';

export default function JoinFormCard({ config, documents = [], documentsEnabled = false, onEdit }) {
  const { enabled, questions = [] } = config || {};
  const requiredJoinDocuments = documentsEnabled ? getRequiredJoinDocuments(documents) : [];
  const forcedByDocuments = requiredJoinDocuments.length > 0;
  const effectiveEnabled = enabled || forcedByDocuments;

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Join Form</span>
        <EditButton section="joinFormConfig" onEdit={onEdit} />
      </div>
      <div className="card-body">
        {effectiveEnabled ? (
          <>
            <p>
              Custom join form is <strong>enabled</strong> with {questions.length} question{questions.length !== 1 && 's'}.
            </p>

            {forcedByDocuments && (
              <p className="text-muted" style={{ marginTop: '0.5rem' }}>
                {requiredJoinDocuments.length} required join document{requiredJoinDocuments.length !== 1 && 's'} also keep this step active.
              </p>
            )}

            {questions.length > 0 && (
              <ul className="join-form-question-list" style={{ marginTop: '0.5rem', paddingLeft: '1rem' }}>
                {questions.map((q, i) => (
                  <li key={q.id || i}>
                    {q.label} {q.required && <strong style={{ color: 'red' }}>*</strong>}
                  </li>
                ))}
              </ul>
            )}
          </>
        ) : (
          <p>Join form is currently <strong>disabled</strong>.</p>
        )}
      </div>
    </div>
  );
}
